import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  Alert,
  Box,
  Button,
  Container,
  Paper,
  Typography,
} from '@mui/material';

import Logo from '@giro/shared-components/Logo.component';

// The Giro Android app receives this link and runs the gTapp accreditation flow.
const buildGtappDeepLink = (id: string, otp: string) =>
  `gtapp://accredit?id=${encodeURIComponent(id)}&otp=${encodeURIComponent(
    otp
  )}`;

const TerminalAccreditationScreen = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const id = (params.get('id') || '').trim();
  const otp = (params.get('otp') || '').trim();
  const [openAttempted, setOpenAttempted] = React.useState(false);

  const valid = /^\d+$/.test(id) && /^\d{8}$/.test(otp);
  const deepLink = valid ? buildGtappDeepLink(id, otp) : '';

  React.useEffect(() => {
    setOpenAttempted(false);
  }, [search]);

  return (
    <Box
      component="main"
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgcolor="trasso.gray.20"
      px={2}
      py={6}
      sx={{
        '& .MuiTypography-root': { fontFamily: "'Work Sans', sans-serif" },
      }}
    >
      <Container maxWidth="xs" disableGutters>
        <Paper
          sx={{ p: { xs: 3, sm: 4 }, borderRadius: 3, textAlign: 'center' }}
          elevation={2}
        >
          <Box mb={4} display="flex" justifyContent="center">
            <Logo
              variant="new"
              alt="Giro Pagamentos"
              width={208}
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </Box>

          <Typography
            variant="trasso_body_small"
            color="trasso.purple.60"
            component="div"
            mb={1}
          >
            Tap on Phone
          </Typography>
          <Typography
            variant="trasso_heading_medium"
            color="trasso.purple.100"
            component="h1"
            mb={2}
            sx={{ fontSize: 26, fontWeight: 600 }}
          >
            {valid ? 'Ative seu dispositivo' : 'Link de ativação inválido'}
          </Typography>

          {valid ? (
            <>
              <Typography
                variant="trasso_body_small"
                color="trasso.purple.60"
                component="p"
                mb={3}
              >
                Receba pagamentos por aproximação no seu Android com NFC.
                Conclua a ativação no aplicativo Giro Pagamentos.
              </Typography>

              <Button
                fullWidth
                variant="contained"
                size="large"
                href={deepLink}
                onClick={() => setOpenAttempted(true)}
              >
                Abrir aplicativo Giro
              </Button>

              {openAttempted && (
                <Alert
                  severity="info"
                  role="status"
                  sx={{
                    mt: 3,
                    textAlign: 'left',
                    fontSize: 14,
                    lineHeight: 1.5,
                  }}
                >
                  O aplicativo não abriu? Use o navegador do celular Android e
                  confira se o Giro Pagamentos está instalado e atualizado com
                  suporte a Tap on Phone.
                </Alert>
              )}

              <Typography
                variant="trasso_body_extra_small"
                color="trasso.purple.60"
                component="p"
                mt={3}
                sx={{ lineHeight: 1.5 }}
              >
                Use o celular em que você vai receber pagamentos. Se estiver no
                computador, escaneie o QR Code com esse celular.
              </Typography>
            </>
          ) : (
            <Alert
              severity="error"
              sx={{ textAlign: 'left', fontSize: 14, lineHeight: 1.5 }}
            >
              Este link está incompleto ou inválido. No Portal, acesse Tap on
              Phone e gere um novo QR Code para o dispositivo.
            </Alert>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default TerminalAccreditationScreen;
